export const setUser = ({ userID, section }) => state => {
  const user = state.users.find(user => user.id === userID) || {
    id: undefined,
    name: undefined,
  };

  return {
    ...state,
    [section]: {
      ...state[section],
      user,
    },
  };
};
